// extracted by mini-css-extract-plugin
module.exports = {"iconButtons":"GroupTable_iconButtons__2ewuq","actions":"GroupTable_actions__2eRss","deleteModalFooter":"GroupTable_deleteModalFooter__OC0v0"};